import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=3f2e1dba&"
import script from "./Clients.vue?vue&type=script&lang=ts&"
export * from "./Clients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2e1dba')) {
      api.createRecord('3f2e1dba', component.options)
    } else {
      api.reload('3f2e1dba', component.options)
    }
    module.hot.accept("./Clients.vue?vue&type=template&id=3f2e1dba&", function () {
      api.rerender('3f2e1dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Client/Clients.vue"
export default component.exports